function trimBase(url) {
  return (url || '').replace(/\/$/, '')
}

function mediaPath(url) {
  if (!url) return ''
  let path = String(url).trim()
  const bases = [
    process.env.VUE_APP_PUBLIC_API_URL,
    process.env.VUE_APP_PROXY_TARGET,
    'http://localhost:9000',
    'http://127.0.0.1:9000',
  ]
    .filter(Boolean)
    .map(trimBase)

  for (const base of bases) {
    if (path.startsWith(`${base}/`)) {
      path = path.slice(base.length)
      break
    }
  }

  if (!path.startsWith('/')) {
    path = path.startsWith('uploads/') ? `/${path}` : path
  }
  return path.split('?')[0]
}

export function resolveMediaUrl(url) {
  const path = mediaPath(url)
  return path || url || ''
}

export function publicMediaUrl(url) {
  const path = mediaPath(url)
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path

  const base = trimBase(process.env.VUE_APP_PUBLIC_API_URL || process.env.VUE_APP_FRONTEND_URL || '')
  if (!base) return path
  return `${base}${path.startsWith('/') ? path : `/${path}`}`
}
